module.exports = __webpack_public_path__ + "img/devourer.7c651f98.png";